import { modifier } from 'ember-modifier';
import { timeout } from 'ember-concurrency';

export default modifier(async function focusAfterTransition(element) {
  await timeout(0);
  element.focus();
});
